export default "__VITE_ASSET__VRJ_zq_$__"